import { render, staticRenderFns } from "./form-details.vue?vue&type=template&id=4c100c56"
import script from "./form-details.vue?vue&type=script&lang=js"
export * from "./form-details.vue?vue&type=script&lang=js"
import style0 from "./form-details.vue?vue&type=style&index=0&id=4c100c56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports